// Asset names are not unique, so always key on id. sfid is set only for assets that exist in Salesforce.
export type RoomAssetLink = {
  id: string;
  sfid?: string;
  name: string;
};

export type UpliftType = 'property_net' | 'bundled_experience' | 'combined';

// A linked experience available to bundle into a package upgrade.
export type Experience = {
  id: string;
  luxPlus: string;
  travelTo: string;
  accountName: string;
  dealOptionName: string;
  fareType: string;
  dealCategory: string;
  subCategory: string;
  ancillarySellPriceUplift: number;
  valueCostCurrency: number;
  currency: string;
  destination: string;
  subDestination: string;
};

// Snapshot at attach time, so reporting survives the source experience changing or disappearing.
export type AttachedExperience = {
  id: string;
  dealOptionName: string;
  ancillarySellPriceUplift: number;
  valueCostCurrency: number;
  currency: string;
  costAud: number;
};

export const roomVariantKey = (room: Pick<CategoryRoom, 'assetId' | 'packageName'>) =>
  `${room.assetId}::${room.packageName}`;

export type PackageOptionId = string;

export type CategoryRoom = {
  id: PackageOptionId;
  assetId: string;
  assetName: string;
  asiaOnly: boolean;
  packageName: string;
  upliftType?: UpliftType;
  experiences?: Array<AttachedExperience>;
  propertyNetLift?: number;
};

export type RoomPricing = {
  allocation: string;
  occupancy: string;
  sellByLos: Record<number, string>;
  sellEditedByLos: Record<number, boolean>;
  netByLos: Record<number, string>;
  extraNightSell: string;
  extraNightSellEdited: boolean;
  extraNightNet: string;
  otaPrice: string;
  netPercent?: number;
};

export type NetRateFormulaState = {
  netPercent: string;
  applyToExtraNight: boolean;
  scope: 'all' | 'choose';
  selectedRoomIds: Array<PackageOptionId>;
};

export type OptionState = {
  lengthsOfStay: Array<number>;
  roomsByCategory: Array<Array<CategoryRoom>>;
  selectedLos: number;
  pricingByRoomId: Record<PackageOptionId, RoomPricing>;
  netRateFormula: NetRateFormulaState;
};
